module.exports = __webpack_public_path__ + "img/Hanover_logo.4822d30b.png";